module.exports = __webpack_public_path__ + "public/images/turtle.72a6165b41886047086195a2c5a6c4c8.png";